import moment from "moment";
import * as XLSX from "xlsx";
import { sanitizeRows } from "utils/exportSanitize";
import { debounce } from "lodash";
import { toastr } from "react-redux-toastr";
import { useAuth0 } from "@auth0/auth0-react";
import Pagination from "@material-ui/lab/Pagination";
import { IconButton, Table, CircularProgress } from "@material-ui/core";
import { TableContainer, Dialog, TableBody } from "@material-ui/core";
import React, { memo, useCallback, useEffect, useState } from "react";
import { TableCell, TableHead, TableRow, Paper } from "@material-ui/core";
// component
import Loader from "components/loader/Loader";
import { formatDate } from "helper/dateFormat";
import DonationService from "Lib/API/Donation";
import Button from "components/button/Button.jsx";
import AlertDialog from "components/Dialog/index";
import { numberFormat } from "helper/numberFormat";
import { MyCheckbox } from "components/MyCheckbox";
import sortImg from "assets/icons/sort-able-svg.svg";
import ClearGroupFilter from "components/clearGroupFilter";
import ExportOptions from "components/ExportOptions/ExportOptions";
import SendDonationLetter from "components/SendLetter/SendDonationLetter";
// direct import
import "./styles.scss";
import ExpandableRow from "./TributeTableData";
import { tributeColumns } from "./TributeLetterData";
import { displayStatus, tableHeading } from "./helper";
const TributeLetterTable = ({
  filters,
  sortCharged,
  formik,
  setEditTribute,
  setEditTributeData,
  setViewClick,
  viewClick,
  page,
  setPage,
  applyFilter,
  setApplyFilter,
  searchValue,
  filterApplied,
  openBulkTagging,
  handleRowClick,
  check,
  setCheck,
  checkAll,
  setCheckAll,
  handlePrintDonation,
  downloadLoader,
}) => {
  const tableContainerRef = React.createRef();
  const { getAccessTokenSilently } = useAuth0();
  // state
  const [count, setCount] = useState();
  const [loading, setLoading] = useState(false);
  const [exportData, setExportData] = useState([]);
  const [productData, setProductData] = useState();
  const [tributeAdd, setTributeAdd] = useState(false);
  const [tributeList, setTributeList] = useState(false);
  const [savetribute, setsavetribute] = useState(false);
  const [confirmClose, setConfirmClose] = useState(false);
  const [selectedLetter, setSelectedLetter] = useState(null);
  const [isExportLoading, setIsExportLoading] = useState(false);
  const [openLetterModal, setOpenLetterModal] = useState(false);
  const [sendLetterLoading, setSendLetterLoading] = useState(false);

  const getFilterData = () => {
    const filterData = {};

    if (formik.values?.filterValues?.dateRange?.length) {
      filterData.dateRange = {
        start: formik.values?.filterValues?.dateRange[0],
        end: formik.values?.filterValues?.dateRange[1],
      };
    }
    if (formik.values?.filterValues?.status) {
      filterData.status = formik.values?.filterValues?.status;
    }
    if (formik.values?.filterValues?.type) {
      filterData.type = formik.values?.filterValues?.type;
    }
    if (
      formik.values?.filterValues?.amountRange?.min ||
      formik.values?.filterValues?.amountRange?.max
    ) {
      filterData.amountRange = {
        start:
          formik.values?.filterValues?.amountRange?.min !== ""
            ? formik.values?.filterValues?.amountRange?.min
            : undefined,
        end:
          formik.values?.filterValues?.amountRange?.max !== ""
            ? formik.values?.filterValues?.amountRange?.max
            : undefined,
      };
    }
    if (formik.values?.ledger?.length) {
      filterData.ledger = formik.values?.ledger;
    }
    if (formik.values?.subLedger?.length) {
      filterData.subLedger = formik.values?.subLedger;
    }
    return filterData;
  };

  const fetchMyAPI = useCallback(async (e) => {
    const applyFilterData = filterApplied ? getFilterData() : {};
    setLoading(true);
    const token = await getAccessTokenSilently();
    await DonationService.getListofTributeInfo(token, page + 1, 30, {
      ...filters,
      filter: {
        ...filters?.filter,
        ...applyFilterData,
      },
      search: searchValue || undefined,
    })
      .then((res) => {
        const result = res?.payload?.data;
        setProductData(result);
        setCount(res?.payload?.pagination?.count);
      })
      .catch((err) => {
        toastr.error("Error", err?.data?.message || "Something went wrong");
      })
      .finally(() => {
        applyFilterData && setApplyFilter(false);
        setLoading(false);
      });
  });

  const refetchExport = () => {
    if (filterApplied) {
      setApplyFilter(true);
    }
  };

  const fetchExportAPI = async () => {
    try {
      const applyFilterData = filterApplied ? getFilterData() : {};
      const token = await getAccessTokenSilently();

      const res = await DonationService.getListofTributeInfo(token, 0, 0, {
        ...filters,
        filter: {
          ...filters?.filter,
          ...applyFilterData,
        },
        search: searchValue || undefined,
      });

      setExportData(res?.payload?.data ?? []);
      // return res?.payload?.data ?? [];
    } catch (err) {
      return [];
    }
  };

  const debounceSearch = useCallback(
    debounce(() => {
      if (searchValue) {
        fetchMyAPI();
      }
    }, 1000),
    [searchValue]
  );

  useEffect(() => {
    fetchMyAPI();
  }, [tributeAdd, savetribute]);

  useEffect(() => {
    if (!tributeList) return;
    fetchMyAPI();
  }, [tributeList]);

  useEffect(() => {
    if (searchValue) {
      setPage(0);
      debounceSearch();
    } else {
      fetchMyAPI();
      if (!filters) {
        fetchMyAPI();
      }
    }
    window.addEventListener("save-transaction", fetchMyAPI);
    return () => {
      window.removeEventListener("save-transaction", fetchMyAPI);
      debounceSearch.cancel();
    };
  }, [filters, page, getAccessTokenSilently, searchValue]);

  useEffect(() => {
    if (!applyFilter) return;
    fetchExportAPI();
    fetchMyAPI();
  }, [applyFilter]);

  useEffect(() => {
    if (!filters?.filter?.accountId) return;
    fetchExportAPI();
  }, [filters?.filter?.accountId]);

  const exportDataHandler = () => {
    const getDataToMap = checkAll ? exportData : check;
    const arr = [];
    if (getDataToMap?.length) {
      const tributeData = getDataToMap?.forEach((item) => {
        const sentDate =
          item?.tribute_info?.status === "sent" && item?.tribute_info?.date
            ? formatDate({
                date: item?.tribute_info?.date,
                formatType: "defaultWithUTC",
              })
            : "";

        let tributeObject = {
          id: item?._id,
          donorName: item?.tribute_info?.donorName || item?.Account?.name,
          tributeType: item?.tribute_info?.type,
          recipientName: item?.tribute_info?.name,
          date: formatDate({
            date: item?.tribute_info?.date,
            formatType: "defaultWithUTC",
          }),
          cause: item?.SubLedger?.name || item?.Ledger?.name || "",
          amount: numberFormat({
            number: +item?.total_amount,
            decimal: 2,
            style: "currency",
          }),
          sent: `${displayStatus(item?.tribute_info?.status)} ${sentDate}`,
          tributeMessage: item?.tribute_info?.message,
          paper: item?.tribute_info?.sendPaper ? "Yes" : "No",
          paperAddress: item?.tribute_info?.sendPaper
            ? (() => {
                const street =
                  item?.tribute_info?.address?.location?.formattedAddress?.split(
                    ","
                  )[0] || "";
                const addressLine2 =
                  item?.tribute_info?.address?.addressLine2 || "";
                const city = item?.tribute_info?.address?.city || "";
                const state = item?.tribute_info?.address?.state || "";
                const zip = item?.tribute_info?.address?.zip_code || "";
                return [street, addressLine2, city, state, zip]
                  .filter(Boolean)
                  .join(", ")
                  .replace(/, ([A-Z]{2}),/, " $1,");
              })()
            : "",
        };
        if (item?.tribute_info?.recipients?.length) {
          const recipientData = item?.tribute_info?.recipients?.forEach(
            (recipient, index) => {
              tributeObject = {
                ...(index === 0
                  ? { ...tributeObject }
                  : {
                      donorName: "",
                      tributeType: "",
                      recipientName: "",
                      date: "",
                      cause: "",
                      amount: "",
                      sent: "",
                      tributeMessage: "",
                      paper: item?.tribute_info?.sendPaper ? "Yes" : "No",
                      paperAddress: item?.tribute_info?.sendPaper
                        ? (() => {
                            const street =
                              item?.tribute_info?.address?.location?.formattedAddress?.split(
                                ","
                              )[0] || "";
                            const city =
                              item?.tribute_info?.address?.city || "";
                            const state =
                              item?.tribute_info?.address?.state || "";
                            const zip =
                              item?.tribute_info?.address?.zip_code || "";
                            const addressLine2 =
                              item?.tribute_info?.address?.addressLine2 || "";
                            return [street, addressLine2, city, state, zip]
                              .filter(Boolean)
                              .join(", ")
                              .replace(/, ([A-Z]{2}),/, " $1,");
                          })()
                        : "",
                    }),
                ...(index !== 0
                  ? {
                      id: `${item?._id} - ${recipient?._id}`,
                    }
                  : {}),
                donationRecipientName: recipient?.recipient_name,
                email: recipient?.email,
                paper: item?.tribute_info?.sendPaper ? "Yes" : "No",
                paperAddress: item?.tribute_info?.sendPaper
                  ? (() => {
                      const street =
                        item?.tribute_info?.address?.location?.formattedAddress?.split(
                          ","
                        )[0] || "";
                      const addressLine2 =
                        item?.tribute_info?.address?.addressLine2 || "";
                      const city = item?.tribute_info?.address?.city || "";
                      const state = item?.tribute_info?.address?.state || "";
                      const zip = item?.tribute_info?.address?.zip_code || "";
                      return [street, addressLine2, city, state, zip]
                        .filter(Boolean)
                        .join(", ")
                        .replace(/, ([A-Z]{2}),/, " $1,");
                    })()
                  : "",
              };
              arr.push(tributeObject);
            }
          );
        } else {
          arr.push({
            ...tributeObject,
            donationRecipientName: "",
            email: "",
            paperAddress: "",
            paper: item?.tribute_info?.sendPaper ? "Yes" : "No",
            paperAddress: item?.tribute_info?.sendPaper
              ? (() => {
                  const street =
                    item?.tribute_info?.address?.location?.formattedAddress?.split(
                      ","
                    )[0] || "";
                  const addressLine2 =
                    item?.tribute_info?.address?.addressLine2 || "";
                  const city = item?.tribute_info?.address?.city || "";
                  const state = item?.tribute_info?.address?.state || "";
                  const zip = item?.tribute_info?.address?.zip_code || "";
                  return [street, addressLine2, city, state, zip]
                    .filter(Boolean)
                    .join(", ")
                    .replace(/, ([A-Z]{2}),/, " $1,");
                })()
              : "",
          });
        }
      });
    }
    return arr;
  };

  const generateCsvHandler = () => {
    const tributeList = exportDataHandler();
    return tributeList;
  };

  const reportFileNameHandler = () => {
    const reportName = "Donation";
    const formattedDate = moment().format("MM-DD-YYYY");
    const reportFileName = `${reportName}_${formattedDate}`;
    return reportFileName || "report";
  };

  const generateExcelHandler = () => {
    const getDataToMap = checkAll ? exportData : check;

    setIsExportLoading(true);
    const arr = [];
    if (getDataToMap?.length) {
      const tributeData = getDataToMap?.forEach((item) => {
        const sentDate =
          item?.tribute_info?.status === "sent" && item?.tribute_info?.date
            ? formatDate({
                date: item?.tribute_info?.date,
                formatType: "defaultWithTimeUTC",
              })
            : "";
        let tributeObject = {
          donorName: item?.tribute_info?.donorName || item?.Account?.name,
          tributeType: item?.tribute_info?.type,
          recipientName: item?.tribute_info?.name,
          date: formatDate({
            date: item?.tribute_info?.date,
            formatType: "defaultWithUTC",
          }),
          cause: item?.SubLedger?.name || item?.Ledger?.name || "",
          amount: numberFormat({
            number: +item?.total_amount,
            decimal: 2,
            style: "currency",
          }),
          sent: `${displayStatus(item?.tribute_info?.status)} ${sentDate}`,
          tributeMessage: item?.tribute_info?.message,
          paper: item?.tribute_info?.sendPaper ? "Yes" : "No",
          Address: item?.tribute_info?.sendPaper
            ? (() => {
                const street =
                  item?.tribute_info?.address?.location?.formattedAddress?.split(
                    ","
                  )[0] || "";
                const addressLine2 =
                  item?.tribute_info?.address?.addressLine2 || "";
                const city = item?.tribute_info?.address?.city || "";
                const state = item?.tribute_info?.address?.state || "";
                const zip = item?.tribute_info?.address?.zip_code || "";
                return [street, addressLine2, city, state, zip]
                  .filter(Boolean)
                  .join(", ")
                  .replace(/, ([A-Z]{2}),/, " $1,");
              })()
            : "",
        };
        if (item?.tribute_info?.recipients?.length) {
          const recipientData = item?.tribute_info?.recipients?.forEach(
            (recipient, index) => {
              tributeObject = {
                ...(index === 0 ? { ...tributeObject } : {}),
                donationRecipientName: recipient?.recipient_name,
                email: recipient?.email,
                paper: item?.tribute_info?.sendPaper ? "Yes" : "No",
                Address: item?.tribute_info?.sendPaper
                  ? (() => {
                      const street =
                        item?.tribute_info?.address?.location?.formattedAddress?.split(
                          ","
                        )[0] || "";
                      const addressLine2 =
                        item?.tribute_info?.address?.addressLine2 || "";
                      const city = item?.tribute_info?.address?.city || "";
                      const state = item?.tribute_info?.address?.state || "";
                      const zip = item?.tribute_info?.address?.zip_code || "";
                      return [street, addressLine2, city, state, zip]
                        .filter(Boolean)
                        .join(", ")
                        .replace(/, ([A-Z]{2}),/, " $1,");
                    })()
                  : "",
              };
              arr.push(tributeObject);
            }
          );
        } else {
          arr.push(tributeObject);
        }
      });
    }

    const worksheet = XLSX.utils.json_to_sheet(sanitizeRows(arr));
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    XLSX.writeFile(workbook, `${reportFileNameHandler()}.xlsx`);
    setIsExportLoading(false);
  };

  const headerColumns = tributeColumns;

  const displayRowsPrintTable = () => {
    const tributeList = exportDataHandler();
    const rowPrintTable = (
      <>
        {tributeList?.map((row, index) => (
          <TableRow key={row?.id}>
            {Object.keys(row).map((key) => (
              <>{key !== "id" && <TableCell>{row[key]}</TableCell>}</>
            ))}
          </TableRow>
        ))}
      </>
    );
    return rowPrintTable;
  };

  const openSendLetterModal = (row) => {
    setOpenLetterModal(true);
    setSelectedLetter(row);
  };

  const closeSendLetterModal = () => setConfirmClose(true);

  const confirmCloseHandler = () => {
    setConfirmClose(false);
    setOpenLetterModal(false);
    setSelectedLetter(null);
  };

  const handleSendLetter = async (templateData) => {
    setSendLetterLoading(true);
    const token = await getAccessTokenSilently();
    const bodyData = {
      ...templateData,
      transactionId: selectedLetter?._id,
    };

    DonationService.sendTributeLetter(token, bodyData)
      .then((response) => {
        toastr.success("Success", "Email sent successfully");
        confirmCloseHandler();
        fetchMyAPI();
      })
      .catch((err) => {
        toastr.error("Error", err?.data?.message || "Something went wrong!");
      })
      .finally(() => {
        setSendLetterLoading(false);
      });
  };

  const getInitialEmails = (templateName) => {
    let initialEmails = [];
    if (templateName === "Email to the recipient") {
      const recipientEmails = selectedLetter?.tribute_info?.recipients?.length
        ? selectedLetter?.tribute_info?.recipients?.map((recipient) => {
            return recipient?.email;
          })
        : [];
      initialEmails = recipientEmails;
    } else {
      initialEmails = selectedLetter?.Account?.defaultEmails || [];
    }
    return initialEmails;
  };

  return (
    <div className="w-100">
      <div className="family-table-container pl-7 pr-6 pt-3 pb-22">
        <div
          className="d-flex align-items-center mt-6 mb-6"
          style={{
            gap: "15px",
          }}
        >
          {filters?.filter?.accountId && <ClearGroupFilter />}
          {(filterApplied ||
            filters?.filter?.accountId ||
            check?.length !== 0) && (
            <div className="d-flex justify-content-end flex-grow-1">
              <Button
                onClick={openBulkTagging}
                disabled={!check?.length}
                variant="secondary-light"
                size="md"
                style={{ marginRight: "2rem" }}
              >
                Bulk Tag
              </Button>

              <Button
                onClick={handlePrintDonation}
                disabled={downloadLoader || !check?.length}
                variant="secondary-light"
                size="md"
                style={{ marginRight: "2rem" }}
              >
                Print Donation Letters{" "}
                {downloadLoader && <CircularProgress size={14} />}
              </Button>

              <ExportOptions
                columns={headerColumns}
                datas={generateCsvHandler}
                downloadExcel={generateExcelHandler}
                isLoading={isExportLoading}
                setLoading={setIsExportLoading}
                tableContainerRef={tableContainerRef}
                reportFileNameHandler={reportFileNameHandler}
                buttonStyle={{
                  height: "45px",
                }}
                disabled={!check?.length}
              />
            </div>
          )}
        </div>
        <div
          className={`home-table-container mt-0 no-box-shadow ${
            loading == true ? "tributes-table" : ""
          }`}
        >
          <div className="d-none">
            <TableContainer component={Paper}>
              <Table
                class="main-table"
                aria-label="collapsible table"
                ref={tableContainerRef}
              >
                <TableHead className="charges-table">
                  <TableRow>
                    {headerColumns?.map((column) => (
                      <TableCell
                        className="date-head"
                        key={column?.id}
                        style={{
                          textTransform: "uppercase",
                        }}
                      >
                        {column?.headerName}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody
                  className="tran-table-body"
                  style={{
                    backgroundColor: "white",
                    display: "contents",
                  }}
                >
                  {displayRowsPrintTable()}
                </TableBody>
              </Table>
            </TableContainer>
          </div>

          <TableContainer component={Paper} className="scroll-table">
            <Table aria-label="collapsible table">
              <TableHead className="main-table__header sticky-table-header">
                <TableRow>
                  <TableCell>
                    {filterApplied && (
                      <MyCheckbox
                        checked={checkAll}
                        handlechange={(e) => {
                          const checked = e.target.checked;
                          setCheckAll(checked);
                          setCheck(checked ? productData || [] : []);
                        }}
                      />
                    )}
                  </TableCell>

                  {tableHeading?.map(
                    ({ label, className, align, sortable }) => (
                      <TableCell
                        key={label}
                        className={className}
                        align={align}
                      >
                        {label}
                        {sortable && (
                          <IconButton onClick={() => sortCharged("date")}>
                            <img src={sortImg} alt="sort" />
                          </IconButton>
                        )}
                      </TableCell>
                    )
                  )}

                  <TableCell className="donor-action sticky-header-column" />
                </TableRow>
              </TableHead>

              {productData?.length === 0 ? (
                <td colSpan={12}>
                  <div className="record-text">No record found</div>
                </td>
              ) : loading === true ? (
                <TableRow>
                  <TableCell colSpan={10} align="center">
                    <div className="user__loader" style={{ height: "320px" }}>
                      <Loader />
                    </div>
                  </TableCell>
                </TableRow>
              ) : (
                productData?.map((row) => (
                  <TableBody>
                    <ExpandableRow
                      key={row.name}
                      setsavetribute={setsavetribute}
                      row={row}
                      setTributeAdd={setTributeAdd}
                      setEditTributeData={setEditTributeData}
                      setEditTribute={setEditTribute}
                      setViewClick={setViewClick}
                      check={check}
                      formik={formik}
                      viewClick={viewClick}
                      setTributeList={setTributeList}
                      openSendLetterModal={() => openSendLetterModal(row)}
                      refetchExport={refetchExport}
                      handleRowClick={handleRowClick}
                      checkAll={checkAll}
                      setCheck={setCheck}
                    />
                  </TableBody>
                ))
              )}
            </Table>
          </TableContainer>
          {productData?.length === 0 ? (
            ""
          ) : (
            <div className="pagination-custom mt-2">
              <Pagination
                count={Math.ceil(count / 30)}
                color="primary"
                variant="outlined"
                onChange={(event, value) => {
                  setPage(value - 1);
                }}
                page={page + 1}
              />
            </div>
          )}
        </div>
        <Dialog
          open={openLetterModal}
          onClose={closeSendLetterModal}
          PaperProps={{
            style: {
              width: "888px",
              height: "637px",
              overflowX: "hidden",
              borderRadius: "22px",
            },
          }}
          fullWidth
          maxWidth={"md"}
        >
          <SendDonationLetter
            closeModal={closeSendLetterModal}
            handleSendLetter={handleSendLetter}
            sendLetterLoading={sendLetterLoading}
            type="donation"
            getInitialEmails={getInitialEmails}
          />
        </Dialog>
        <AlertDialog
          open={confirmClose}
          onDecline={() => {
            setConfirmClose(false);
          }}
          onAccept={confirmCloseHandler}
          title={"Are you sure?"}
          description={"Do you want to discard the changes you made?"}
        />
      </div>
    </div>
  );
};

export default memo(TributeLetterTable);
